import { render, staticRenderFns } from "./PendingRequestsEntity.vue?vue&type=template&id=6b25d34f&"
import script from "./PendingRequestsEntity.vue?vue&type=script&lang=js&"
export * from "./PendingRequestsEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports